<template>
 <Head>
    <title> Admin Reports | {{$page.props.appName}}</title>
    <meta name="description" :content="'Admin Reports ' + $page.props.appName">
  </Head>
    <div>
    <h2 class="font-semibold p-3 text-center">Select a report below</h2>
    <div class="w-full flex p-3 xl:flex-row lg:flex-row md:flex-col sm:flex-col flex-col items-center justify-center">
    
    
    
    <Link href="/admin/reports/compmatrix" class="xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold">

    <div class="flex items-center flex-col">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>

        <p>Competency Matrix</p>
    </div>



    </Link>
    
    
    <Link href="/admin/reports/announcementreport" class="xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold">

    <div class="flex items-center flex-col">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>

        <p>Announcement Report</p>
    </div>



    </Link>

     <Link href="/admin/reports/pendingexpiredtickets" class="xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full w-full my-2 h-52 border-radius text-center flex items-center justify-center shadow-md mx-2 bg-black text-white font-bold">

    <div class="flex items-center flex-col">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>

        <p>Pending and Expired Tickets</p>
    </div>



    </Link>
    
    </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link } from '@inertiajs/inertia-vue3'
import { Head } from '@inertiajs/inertia-vue3'

export default {
    layout: Layout,
    props : {
        announcements : Number
    },
    components: { Link,Head }
}
</script>